import React, { Component } from "react";
import "./ViewDeactivate.styles.scss";
// import { css } from "@emotion/core"
import BounceLoader from "react-spinners/BounceLoader";
import axios from "axios";
//import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { format } from "date-fns";
import { Collapse } from "@material-ui/core";
import { Button, Icon, Divider } from "react-materialize";
import Alert from "@material-ui/lab/Alert";
import AxiosClient from "../../../../../../Network/AxiosClient";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Dialog } from "@mui/material";

class ViewDeactivate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErr: false,
      showConfirm: true,
      resigning_date: new Date(),
      showDialog: false,
    };
  }

  handleDateChange = (date) => {
    this.setState({ resigning_date: date });
    //console.log(moment(date).toISOString())
  };

  handleFormSubmit = () => {
    this.setState({ loading: true });

    const { id } = this.props.data;

    // const fd = new FormData();
    // fd.append("id", id);
    // fd.append(
    //   "resigning_date",
    //   //moment(this.state.resigning_date).format("yyyy-MM-dd").toString()
    //   format(new Date(this.state.resigning_date), "yyyy-MM-dd")
    // );

    AxiosClient.delete(
      `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/office-employee`,

      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        data: {
          id: id,
          resigning_date: format(
            new Date(this.state.resigning_date),
            "yyyy-MM-dd"
          ),
        },
      }
    )
      .then((res) => {
        //console.log(res);
        this.props.callBack();
        alert("Deactivation successfull");
      })
      .catch((error) => {
        this.setState({ loading: false, showErr: true });
        console.log(`error updating employee ${error}`);
        if (error.response) {
          alert(error.response.data.message);
        } else if (error.request) {
          alert(error.request);
        } else {
          alert("Something went wrong!");
        }
      });
  };

  render() {
    console.log(this.props.data);

    return (
      <div>
        <Button
          onClick={() => this.setState({ showDialog: true })}
          className="im-secondary"
        >
          Deactivate
        </Button>

        <Dialog
          open={this.state.showDialog}
          onClose={() => this.setState({ showDialog: false })}
        >
          {this.props.data && (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="edit-main" style={{ padding: 40 }}>
                <div className="edit-body">
                  <div className="basic"></div>
                </div>
                {/* <Collapse in={this.props.data.mdo_count !== 0 ? true : false}>
                  <div>
                    <Alert
                      severity="error"
                      variant="outlined"
                      style={{ fontSize: 20, alignItems: "center" }}
                    >
                      <b>{this.props.data.name}</b> is currently assigned to
                      some field forces. Please “Replace FSE” or re-assign
                      existing assigned field forces to another FSE to continue.
                    </Alert>
                    <div className="footer-edit">
                      <button
                        className="button--save"
                        onClick={() => this.setState({ showDialog: false })}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </Collapse> */}
                <Collapse in={true}>
                  <div>
                    <form>
                      {/* <div className="group"> */}
                      <p style={{ marginBottom: -5 }}>
                        Please provide resignation date here
                      </p>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Resigning Date"
                        format="dd/MM/yyyy"
                        value={this.state.resigning_date}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(date) => this.handleDateChange(date)}
                        style={{ width: "400px", margin: "25px auto" }}
                      />
                      {/* </div> */}
                    </form>
                    {this.state.showErr && (
                      <div
                        className="error-msg"
                        style={{
                          color: "red",
                          fontFamily: "monospace",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <span>Something went wrong!</span>
                      </div>
                    )}
                    <div className="footer-edit">
                      <BounceLoader
                        className="loader"
                        color={"#e2136e"}
                        size={20}
                        loading={this.state.loading}
                      />

                      <button
                        className="button--cancel"
                        onClick={this.props.viewMainOnClick}
                      >
                        {" "}
                        Cancel
                      </button>
                      <button
                        className="button--save"
                        onClick={this.handleFormSubmit}
                      >
                        Deactivate
                        {/* {this.props.data.status === "Deactivated"
                        ? "Reactivate"
                        : "Deactivate"} */}
                      </button>
                    </div>
                  </div>
                </Collapse>
              </div>
            </MuiPickersUtilsProvider>
          )}
        </Dialog>
      </div>
    );
  }
}

export default ViewDeactivate;
